














import {Component} from 'vue-property-decorator';
import Slide from '@/presentation/slides/Slide';

@Component({components: {}})
export default class Comment extends Slide {
  get comment() {
    if (this.section.Comment) {
      return this.section.Comment.replace('\n', '<br/>');
    } else {
      return this.data.ranking.sheets[0].comment;
    }
  }
}
